export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7496.0d0b8119.jpg";